export enum KeyboardHotkeys {
  ENTER_EDIT_MODE = 'Control+Shift+KeyE',
  SAVE_EDIT_MODE = 'Control+Shift+KeyS',
  CANCEL_EDIT_MODE = 'Escape',

  BASIC_SEARCH = 'Control+Shift+KeyK',

  FOCUS_ON_ICON_SIDE_PANEL = 'Control+Alt+ArrowRight',
  BLUR_FROM_ICON_SIDE_PANEL = 'Control+Alt+ArrowLeft',
  FOCUS_FROM_SIDE_PANEL_TO_MAIN = 'Control+Alt+ArrowDown',
  FOCUS_FROM_MAIN_TO_SIDE_PANEL = 'Control+Alt+ArrowUp',
}
